<ng-content>
</ng-content>
<div
    [class.required]="required"
    [class.valid]="valid"
></div>